import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import Hero from "./components/Hero";
import Work from "./components/Work";
import Navbar from "../Navbar";
import FloatingIcon from "../FloatingIcon";
import Footer from "../Footer";

import Fade from "react-reveal/Fade";

import "./style.css";

function Home() {
  const workRef = useRef(null);

  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (params.get("view") && params.get("view") === "work") {
      scrollToWork();
    }

    document.title = "Surya Mahla";
  }, [params]);

  const scrollToWork = () => {
    workRef.current.scrollIntoView();
  };

  return (
    <>
      <Navbar workRef={workRef} />
      <Link to="/contact">
        <FloatingIcon />
      </Link>
      <Fade duration={500}>
        <div className="home">
          <Hero scrollToWork={scrollToWork} />
          <hr style={{ border: "1px solid #cfcfcf" }} />
          <div ref={workRef}>
            <Work />
          </div>
          <Footer />
        </div>
      </Fade>
    </>
  );
}

export default Home;
